(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GlucoseIntervention', GlucoseIntervention);

    GlucoseIntervention.$inject = ['$resource'];

    function GlucoseIntervention ($resource) {
        var resourceUrl =  'api/glucose-interventions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/glucose-interventions/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
